import React from 'react';
import { useLocation, Link } from 'react-router-dom';
import { HomeIcon, UsersIcon, ClipboardListIcon, FileSignatureIcon, ScaleIcon, ClockIcon } from 'lucide-react';
export function MobileNavbar() {
  const location = useLocation();
  const pathname = location.pathname;
  const navigation = [{
    name: 'Dashboard',
    icon: HomeIcon,
    path: '/',
    current: pathname === '/'
  }, {
    name: 'Clienti',
    icon: UsersIcon,
    path: '/clienti',
    current: pathname === '/clienti'
  }, {
    name: 'Piani di Rientro',
    icon: ClipboardListIcon,
    path: '/piani-rientro',
    current: pathname === '/piani-rientro'
  }, {
    name: 'Scadenze',
    icon: ClockIcon,
    path: '/scadenze',
    current: pathname === '/scadenze'
  }, {
    name: 'Legal',
    icon: ScaleIcon,
    path: '/legal',
    current: pathname === '/legal'
  }];
  return <div className="fixed bottom-0 w-full bg-white border-t border-gray-100 shadow-sm" data-id="element-887">
      <div className="grid grid-cols-5" data-id="element-888">
        {navigation.map(item => <Link key={item.name} to={item.path} className={`
              flex flex-col items-center justify-center py-2
              ${item.current ? 'text-[#7B68EE]' : 'text-gray-500 hover:text-[#7B68EE]'}
            `} data-id="element-889">
            <item.icon className="h-5 w-5" aria-hidden="true" data-id="element-890" />
            <span className="text-xs mt-1" data-id="element-891">{item.name}</span>
          </Link>)}
      </div>
    </div>;
}